// Hardcoded milestone data for Sanajim 2026
export const milestones = [
  {
    id: 1,
    name: 'رفيق V1.0',
    dueDate: '14 أبريل 2026 — مكتمل',
    icon: '🚗',
    product: 'rafiq',
    tasks: [
      {
        id: '1.1',
        name: 'Backend — Auth + Missions + GPS',
        status: 'done',
        progress: 100,
        dueDate: '13 أبريل 2026',
        assignee: 'CTO Agent + Lead Dev',
        notes: 'اكتمل — 2,909 سطر backend + WebSocket + GPS tracking',
      },
      {
        id: '1.2',
        name: 'Flutter V1.0 — 4 شاشات',
        status: 'done',
        progress: 100,
        dueDate: '13 أبريل 2026',
        assignee: 'CTO Agent + Lead Dev',
        notes: 'اكتمل — 8,481 سطر Flutter + APK تم إرساله',
      },
      {
        id: '1.3',
        name: 'Full Production Backend',
        status: 'done',
        progress: 100,
        dueDate: '14 أبريل 2026',
        assignee: 'Lead Dev Agent (rafiq-full-build)',
        notes: 'اكتمل — 58 API endpoint + Contracts + Payments + Tickets + Analytics + Admin + Notifications',
      },
      {
        id: '1.4',
        name: 'Full Production Flutter — صاحب عمل',
        status: 'done',
        progress: 100,
        dueDate: '14 أبريل 2026',
        assignee: 'Lead Dev Agent (rafiq-full-build)',
        notes: 'اكتمل — Dashboard + Contracts + Payments + Support + Notifications',
      },
      {
        id: '1.5',
        name: 'Flutter — وضع السائق',
        status: 'done',
        progress: 100,
        dueDate: '14 أبريل 2026',
        assignee: 'Lead Dev Agent (rafiq-full-build)',
        notes: 'اكتمل — Accept/Decline + Navigation + Status + Earnings card',
      },
      {
        id: '1.6',
        name: 'Google Maps + Audio',
        status: 'pending',
        progress: 0,
        dueDate: 'يحتاج API keys من Z',
        assignee: '—',
        notes: 'محظور — الكود جاهز بس يحتاج Google Maps API key + OpenRouter key',
      },
      {
        id: '1.7',
        name: 'Build APK + Deploy',
        status: 'pending',
        progress: 0,
        dueDate: '14 أبريل — 22:30 KSA',
        assignee: 'Lead Dev Agent',
        notes: 'في الانتظار — بعد اكتمال Flutter',
      },
    ]
  },
  {
    id: 2,
    name: 'موافق V1.0',
    dueDate: '14 أبريل 2026 — مكتمل',
    icon: '✅',
    product: 'muwafaq',
    tasks: [
      {
        id: '2.1',
        name: 'واجهة الامتثال',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-13',
        assignee: 'CTO Agent',
        notes: 'اكتمل بنجاح — الواجهة الرئيسية جاهزة',
      },
      {
        id: '2.2',
        name: 'رفع الأدلة',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-13',
        assignee: 'CTO Agent',
        notes: 'اكتمل بنجاح — نظام رفع الملفات يعمل',
      },
      {
        id: '2.3',
        name: 'محرك بحث الامتثال',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-13',
        assignee: 'CTO Agent',
        notes: 'اكتمل بنجاح — البحث والتصفية يعملان',
      },
      {
        id: '2.4',
        name: '181 ضابط (NCA + NORA + SAMA + ISO + PDPL)',
        status: 'done',
        progress: 100,
        dueDate: '14 أبريل 2026',
        assignee: 'Lead Dev Agent (muwafaq-full-build)',
        notes: 'اكتمل — 111 NCA + 15 NORA + 20 SAMA + 25 ISO + 10 PDPL',
      },
      {
        id: '2.5',
        name: 'Frontend كامل — 11 صفحة',
        status: 'done',
        progress: 100,
        dueDate: '14 أبريل 2026',
        assignee: 'Lead Dev Agent (muwafaq-full-build)',
        notes: 'اكتمل — Login + Register + Dashboard + Controls + Audit + Reports + Tickets + Settings',
      },
      {
        id: '2.7',
        name: 'خطة تصحيحية — DB Schema + Endpoints + Frameworks',
        status: 'in_progress',
        progress: 0,
        dueDate: '2026-04-16',
        assignee: 'Planner + Implementer + Tester Agents',
        notes: '🔴 ACTIVE — 3 إيجنتات تعمل في الخلفية: Planner (تخطيط) + Implementer (تنفيذ) + Tester (اختبار). النقاط: 1) DB migration assigned_controls 2) 3 endpoints ناقصة 3) NDMO/SAMA frameworks 4) Arabic domain fix 5) Compliance pipeline 6) ops-api stability',
      },
      {
        id: '2.8',
        name: 'DB Schema Migration — assigned_controls',
        status: 'pending',
        progress: 0,
        dueDate: '2026-04-16',
        assignee: 'Implementer Agent',
        notes: 'P0 — 500 errors على control-assignment endpoints. Fix: ALTER TABLE users ADD COLUMN assigned_controls',
      },
      {
        id: '2.9',
        name: 'implement Missing Endpoints (analytics, health, status)',
        status: 'pending',
        progress: 0,
        dueDate: '2026-04-16',
        assignee: 'Implementer Agent',
        notes: 'P0 — 3 endpoints مو مطبقة: admin/analytics/daily, admin/system/health, compliance/status',
      },
      {
        id: '2.10',
        name: 'Populate NDMO + SAMA + ISO + NORA + PDPL Frameworks',
        status: 'pending',
        progress: 0,
        dueDate: '2026-04-17',
        assignee: 'Implementer Agent',
        notes: 'P1 — بس NCA ECC فيه بيانات، الباقي بدون محتوى. لازم populate كامل',
      },
      {
        id: '2.11',
        name: 'Arabic Domain Name Fix + Data Cleanup',
        status: 'pending',
        progress: 0,
        dueDate: '2026-04-16',
        assignee: 'Implementer Agent',
        notes: 'P1 — Cybersecurity Defense domain فيه mismatch في الأسماء العربية',
      },
      {
        id: '2.12',
        name: 'ops-api PM2 Process Manager',
        status: 'pending',
        progress: 0,
        dueDate: '2026-04-16',
        assignee: 'Implementer Agent',
        notes: 'P1 — ops-api يموت كل شوية، لازم نضيفه لـ PM2',
      },
    ],
  },
  {
    id: 3,
    name: 'صحى V1.0',
    dueDate: '2026-06-01',
    icon: '🏥',
    product: 'sahha',
    tasks: [
      {
        id: '3.1',
        name: 'واجهة المطالبات',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-13',
        assignee: 'CTO Agent',
        notes: 'اكتمل بنجاح — واجهة المطالبات جاهزة',
      },
      {
        id: '3.2',
        name: 'تحليل AI للمخاطر',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-13',
        assignee: 'CTO Agent',
        notes: 'اكتمل بنجاح — نموذج التحليل يعمل',
      },
      {
        id: '3.3',
        name: 'إعادة تقديم المطالبات',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-13',
        assignee: 'CTO Agent',
        notes: 'اكتمل بنجاح — نظام إعادة التقديم يعمل',
      },
      {
        id: '3.4',
        name: 'ربط NPHIES',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-14',
        assignee: 'CTO Agent (sahha-infra-build)',
        notes: 'اكتمل — mock integration layer كامل + API service + routes + config',
      },
      {
        id: '3.5',
        name: 'تقارير العيادات',
        status: 'pending',
        progress: 0,
        dueDate: '2026-04-18',
        assignee: 'CTO Agent',
        notes: 'في قائمة الانتظار — يبدأ بعد NPHIES',
      },
    ],
  },
  {
    id: 4,
    name: 'لوحة تحكم سناجم',
    dueDate: '2026-04-20',
    icon: '📊',
    product: 'dashboard',
    tasks: [
      {
        id: '4.1',
        name: 'تصميم المركز القيادي',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-13',
        assignee: 'CTO Agent',
        notes: 'اكتمل بنجاح — التصميم التنفيذي جاهز',
      },
      {
        id: '4.2',
        name: 'بيانات حقيقية من API',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-15',
        assignee: 'CTO Agent (dashboard-cto-fix)',
        notes: 'اكتمل — جميع الخدمات API تعمل مع CORS ومعالجة الأخطاء',
      },
      {
        id: '4.3',
        name: '3 مستويات drill-down',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-15',
        assignee: 'CTO Agent (dashboard-cto-fix)',
        notes: 'اكتمل — التنقل بين المشاريع → الإصدارات → المهام يعمل كاملاً',
      },
      {
        id: '4.4',
        name: 'تنبيهات التأخير',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-15',
        assignee: 'CTO Agent (dashboard-cto-fix)',
        notes: 'اكتمل — نظام التنبيهات يعرض المهام المتأخرة والمستحقة خلال ٢٤ ساعة',
      },
    ],
  },
  {
    id: 5,
    name: 'بوابة العمالة',
    dueDate: '2026-07-01',
    icon: '👷',
    product: 'labor',
    tasks: [
      {
        id: '5.1',
        name: 'تحليل مالي (CFO)',
        status: 'done',
        progress: 100,
        dueDate: '14 أبريل 2026',
        assignee: 'CFO Agent',
        notes: 'اكتمل — ROI 400-1800%، تعادل الشهر 4-6',
      },
      {
        id: '5.2',
        name: 'تحليل تقني (CTO)',
        status: 'done',
        progress: 100,
        dueDate: '14 أبريل 2026',
        assignee: 'CTO Agent',
        notes: 'اكتمل — Functional Design Document 898 سطر',
      },
      {
        id: '5.3',
        name: 'تحليل تسويقي',
        status: 'done',
        progress: 100,
        dueDate: '14 أبريل 2026',
        assignee: 'Marketing Agent',
        notes: 'اكتمل — CAC < 80 ريال، استراتيجية تسويقية',
      },
      {
        id: '5.4',
        name: 'تحليل السوق',
        status: 'done',
        progress: 100,
        dueDate: '14 أبريل 2026',
        assignee: 'Research Agent',
        notes: 'اكتمل — السوق 1.8B ريال، نمو 18-22%',
      },
      {
        id: '5.5',
        name: 'Backend — قاعدة بيانات + Auth',
        status: 'done',
        progress: 100,
        dueDate: '14 أبريل 2026',
        assignee: 'Lead Dev Agent',
        notes: 'اكتمل — 25+ جدول SQLite + JWT + OTP + ربط الغرفة التجارية',
      },
      {
        id: '5.6',
        name: 'Backend — 60+ API endpoint كاملة',
        status: 'done',
        progress: 100,
        dueDate: '14 أبريل 2026',
        assignee: 'Lead Dev Agent',
        notes: 'اكتمل — Offers + Requests + Bidding + Contracts + Notifications + Admin + Packages',
      },
      {
        id: '5.7',
        name: 'Deploy — PM2 + Nginx',
        status: 'done',
        progress: 100,
        dueDate: '14 أبريل 2026',
        assignee: 'Lead Dev Agent',
        notes: 'اكتمل — Labor Portal backend (port 8083) + nginx configured for labor.sanajim.com. Frontend test page served successfully. Waiting for DNS record to be added in Namecheap.',
      },
      {
        id: '5.8',
        name: 'Flutter App — تسجيل + تصفح + طلبات',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-14',
        assignee: 'Lead Dev Agent (labor-flutter-build)',
        notes: 'اكتمل — 18+ production screens + Riverpod + Arabic RTL + 60+ API endpoints + Firebase + offline support',
      },
      {
        id: '5.9',
        name: 'Web Rebuild — Project Setup + Config',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-16',
        assignee: 'CTO Agent (labor-web-rebuild)',
        notes: 'اكتمل — React 18 + Vite + Tailwind CSS + same stack as Muwafaq. All config files created.',
      },
      {
        id: '5.10',
        name: 'Web Rebuild — API Client + Auth + Layout',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-16',
        assignee: 'CTO Agent (labor-web-rebuild)',
        notes: 'اكتمل — Axios client with 40+ API functions, JWT AuthContext, responsive sidebar Layout with 10 nav items + mobile bottom nav.',
      },
      {
        id: '5.11',
        name: 'Web Rebuild — Dashboard + Login + Register',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-16',
        assignee: 'CTO Agent (labor-web-rebuild)',
        notes: 'اكتمل — Admin Dashboard (Recharts), Business Dashboard (stat cards + bar chart), Login, Register pages with glass morphism orange theme.',
      },
      {
        id: '5.12',
        name: 'Web Rebuild — Labors + Offers + Requests + Contracts',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-16',
        assignee: 'CTO Agent (labor-web-rebuild)',
        notes: 'اكتمل — Labors CRUD + Offers browse + Requests list + Contracts with tabs (active/pending/past). All with glass morphism orange theme.'
      },
      {
        id: '5.13',
        name: 'Web Rebuild — Bids + Special Requests + Tickets',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-16',
        assignee: 'CTO Agent (labor-web-rebuild)',
        notes: 'اكتمل — Bids list + Special Requests with tabs + Tickets upgraded: split view (list+detail), inline reply, status badges, type icons, Muwafaq-quality.'
      },
      {
        id: '5.14',
        name: 'Web Rebuild — Admin + Notifications + Settings',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-16',
        assignee: 'CTO Agent (labor-web-rebuild)',
        notes: 'اكتمل — Admin (dashboard/users/reports Recharts), Notifications upgraded: click-to-mark-read, delete, type-styled. Settings upgraded: 3-tab (account+packages+users), admin user management table.',
      },
      {
        id: '5.15',
        name: 'Web Rebuild — Production Build + Deploy',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-16',
        assignee: 'CTO Agent (labor-web-rebuild)',
        notes: 'اكتمل — vite build ناجح + deployed to labor.sanajim.com + nginx SPA fallback configured.',
      },
      {
        id: '5.16',
        name: 'QA — Full Testing Report',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-16',
        assignee: 'QA Agent (saqer)',
        notes: 'اكتمل — تقرير QA شامل: 4 bugs حرجة (login endpoint خاطئ + register function missing + JWT secret hardcoded + accessToken/token mismatch), 3 bugs عالية, 3 متوسطة. الواجهة ممتازة (RTL + glass morphism) بس login/register معطّلين بالكامل.',
      },
      {
        id: '5.17',
        name: 'CTO Fix — 4 Critical + 2 High Bugs',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-16',
        assignee: 'CTO Agent (cto-fix-labor-bugs)',
        notes: 'اكتمل — Login endpoint → web-login, accessToken → token, register function added, JWT secret hardened (env var required), contracts/bids GET handlers, packages auth middleware. Frontend rebuilt + deployed.',
      },
    ]
  },
  {
    id: 6,
    name: 'بنية تحتية',
    dueDate: '2026-04-15',
    icon: '🏗️',
    product: 'infra',
    tasks: [
      {
        id: '6.1',
        name: 'HTTPS + Domain',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-13',
        assignee: 'Saqer Agent',
        notes: 'اكتمل بنجاح — جميع الخدمات على HTTPS',
      },
      {
        id: '6.2',
        name: 'تأمين VPS',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-13',
        assignee: 'Saqer Agent',
        notes: 'اكتمل بنجاح — الجدار الناري والSSH مؤمّنان',
      },
      {
        id: '6.3',
        name: 'CI/CD Pipeline',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-14',
        assignee: 'CTO Agent (sahha-infra-build)',
        notes: 'اكتمل — GitHub Actions workflow + deploy scripts + nginx configs + PM2 ecosystem files',
      },
      {
        id: '6.4',
        name: 'DNS Configuration (Namecheap)',
        status: 'blocked',
        progress: 0,
        dueDate: '2026-04-14',
        assignee: 'CTO Agent',
        notes: 'BLOCKED: Provided credentials (zakariya75 / Azr%fEe!B9CEQMC) are invalid. Namecheap login fails with "password does not match". Labor Portal is fully configured on server (nginx + backend). Need correct Namecheap credentials to add labor.sanajim.com A record (147.135.208.253).',
      },
      {
        id: '6.5',
        name: 'مراقبة 24/7',
        status: 'pending',
        progress: 0,
        dueDate: '2026-04-16',
        assignee: 'CTO Agent',
        notes: 'في قائمة الانتظار — Prometheus + Grafana',
      },
    ],
  },
  {
    id: 7,
    name: 'مطابقة NCA ECC-2:2024',
    dueDate: '2026-04-18',
    icon: '🔐',
    product: 'ncaEcc',
    tasks: [
      {
        id: '7.1',
        name: 'تقييم الضوابط الأولي',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-17',
        assignee: 'Saqer Agent',
        notes: 'اكتمل — 111 ضابط تم تقييمها، 30 قيد التنفيذ',
      },
      {
        id: '7.2',
        name: 'إصلاح كلمات المرور والـ JWT',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-17',
        assignee: 'Saqer Agent',
        notes: 'اكتمل — سياسة كلمات مرور قوية + أسرار JWT مُولّدة',
      },
      {
        id: '7.3',
        name: 'الجدار الناري والحماية',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-17',
        assignee: 'Saqer Agent',
        notes: 'اكتمل — UFW + fail2ban + Rate Limiting + Helmet',
      },
      {
        id: '7.4',
        name: 'خطة المطابقة التفصيلية',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-17',
        assignee: 'Saqer Agent',
        notes: 'اكتمل — خطة 3 مراحل: مجاني → منخفض التكلفة → استثمار',
      },
      {
        id: '7.5',
        name: 'النسخ الاحتياطي الآلي',
        status: 'in_progress',
        progress: 30,
        dueDate: '2026-04-20',
        assignee: 'CTO Agent',
        notes: 'قيد التنفيذ — Phase 1: نسخ يومية للسيرفر',
      },
      {
        id: '7.6',
        name: 'سجلات الأمان',
        status: 'pending',
        progress: 0,
        dueDate: '2026-04-22',
        assignee: 'CTO Agent',
        notes: 'Phase 1 — Winston/Morgan logging',
      },
      {
        id: '7.7',
        name: 'حماية Cloudflare',
        status: 'pending',
        progress: 0,
        dueDate: '2026-04-25',
        assignee: 'CTO Agent',
        notes: 'Phase 2 — DDoS + WAF مجاني',
      },
      {
        id: '7.8',
        name: 'MFA للإدارة',
        status: 'pending',
        progress: 0,
        dueDate: '2026-05-01',
        assignee: 'Security Agent',
        notes: 'Phase 3 — Google Authenticator',
      },
    ],
  },
  {
    id: 8,
    name: 'منصة التداول V1.0',
    dueDate: '2026-04-20',
    icon: '📈',
    product: 'trading',
    tasks: [
      {
        id: '8.1',
        name: 'Backend API — Portfolio + Auth',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-20',
        assignee: 'Lead Dev Agent',
        notes: 'اكتمل — Node.js + Express + JWT + Bcrypt + Portfolio API + Stocks API + Strategies API + Analysis API',
      },
      {
        id: '8.2',
        name: 'Frontend — لوحة تحكم RTL عربية',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-20',
        assignee: 'Lead Dev Agent',
        notes: 'اكتمل — React + Vite + TailwindCSS + 7 صفحات + ثيم داكن + عربية RTL',
      },
      {
        id: '8.3',
        name: 'تسجيل الدخول الآمن',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-20',
        assignee: 'Lead Dev Agent',
        notes: 'اكتمل — JWT authentication + Bcrypt + Protected routes + Login page',
      },
      {
        id: '8.4',
        name: '5 استراتيجيات استثمارية',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-20',
        assignee: 'CTO Agent',
        notes: 'اكتمل — نمو، قيمة، أرباح، دوران قطاعي، محاكاة المؤشر',
      },
      {
        id: '8.5',
        name: 'تكامل AI (DeepSeek + GPT-4o)',
        status: 'done',
        progress: 100,
        dueDate: '2026-04-20',
        assignee: 'Lead Dev Agent',
        notes: 'اكتمل — تحليل AI للأسهم، تقييم 1-100، إشارات شراء/بيع',
      },
      {
        id: '8.6',
        name: 'Live Tadawul Data',
        status: 'pending',
        progress: 0,
        dueDate: '2026-04-25',
        assignee: 'Research Agent',
        notes: 'Phase 2 — تكامل بيانات حية من تداول API',
      },
      {
        id: '8.7',
        name: 'Telegram Bot للتنبيهات',
        status: 'pending',
        progress: 0,
        dueDate: '2026-04-30',
        assignee: 'Lead Dev Agent',
        notes: 'Phase 2 — إشعارات أسعار وأرباح عبر Telegram',
      },
    ],
  },
]

// Product config
export const products = {
  rafiq:    { key: 'rafiq',    label: 'رفيق',          icon: '🚗', primary: '#00BFA5', light: '#00E5CC', gradient: 'linear-gradient(135deg, #00BFA5, #00E5CC)' },
  muwafaq:  { key: 'muwafaq',  label: 'موافق',         icon: '✅', primary: '#4CAF50', light: '#81C784', gradient: 'linear-gradient(135deg, #4CAF50, #81C784)' },
  sahha:    { key: 'sahha',    label: 'صحة',           icon: '🏥', primary: '#448AFF', light: '#82B1FF', gradient: 'linear-gradient(135deg, #448AFF, #82B1FF)' },
  dashboard:{ key: 'dashboard',label: 'لوحة التحكم',   icon: '📊', primary: '#8B5CF6', light: '#C084FC', gradient: 'linear-gradient(135deg, #8B5CF6, #C084FC)' },
  labor:    { key: 'labor',    label: 'بوابة العمالة', icon: '👷', primary: '#FF6B35', light: '#FF9E6D', gradient: 'linear-gradient(135deg, #FF6B35, #FF9E6D)' },
  infra:    { key: 'infra',    label: 'بنية تحتية',     icon: '🏗️', primary: '#F59E0B', light: '#FCD34D', gradient: 'linear-gradient(135deg, #F59E0B, #FCD34D)' },
  ncaEcc:   { key: 'ncaEcc',   label: 'مطابقة NCA',    icon: '🔐', primary: '#E11D48', light: '#FB7185', gradient: 'linear-gradient(135deg, #E11D48, #FB7185)' },
  trading:  { key: 'trading',  label: 'منصة التداول',   icon: '📈', primary: '#00BCD4', light: '#4DD0E1', gradient: 'linear-gradient(135deg, #00BCD4, #4DD0E1)' },
  aiRacingGame: { key: 'aiRacingGame', label: 'AI Racing', icon: '🏎️', primary: '#FF4081', light: '#FF79B0', gradient: 'linear-gradient(135deg, #FF4081, #FF79B0)' },
  aiRacingGame: { key: 'aiRacingGame', label: 'AI Racing Game', icon: '🏎️', primary: '#FF4081', light: '#FF79B0', gradient: 'linear-gradient(135deg, #FF4081, #FF79B0)' },
}

export function getProductConfig(productKey) {
  return products[productKey] || products.dashboard
}

export function getMilestoneStats(milestone) {
  const total = milestone.tasks.length
  const done = milestone.tasks.filter(t => t.status === 'done').length
  const inProgress = milestone.tasks.filter(t => t.status === 'in_progress').length
  const pending = milestone.tasks.filter(t => t.status === 'pending').length
  const overdue = milestone.tasks.filter(t => t.status === 'overdue').length
  const avgProgress = total > 0 ? Math.round(milestone.tasks.reduce((sum, t) => sum + t.progress, 0) / total) : 0
  return { total, done, inProgress, pending, overdue, avgProgress }
}

export function getOverallStats() {
  const allTasks = milestones.flatMap(m => m.tasks)
  const total = allTasks.length
  const done = allTasks.filter(t => t.status === 'done').length
  const inProgress = allTasks.filter(t => t.status === 'in_progress').length
  const pending = allTasks.filter(t => t.status === 'pending').length
  const overdue = allTasks.filter(t => t.status === 'overdue').length
  const avgProgress = total > 0 ? Math.round(allTasks.reduce((sum, t) => sum + t.progress, 0) / total) : 0
  return { total, done, inProgress, pending, overdue, avgProgress }
}

// ─── Arabic Date Parsing ───

const ARABIC_MONTHS = {
  'يناير': 0, 'فبراير': 1, 'مارس': 2, 'أبريل': 3, 'ابريل': 3,
  'مايو': 4, 'يونيو': 5, 'يوليو': 6, 'أغسطس': 7, 'اغسطس': 7,
  'سبتمبر': 8, 'أكتوبر': 9, 'اكتوبر': 9, 'نوفمبر': 10, 'ديسمبر': 11,
  'january': 0, 'february': 1, 'march': 2, 'april': 3, 'may': 4,
  'june': 5, 'july': 6, 'august': 7, 'september': 8, 'october': 9,
  'november': 10, 'december': 11,
}

/**
 * Parse a date string that may be ISO (2026-04-13) or Arabic (14 أبريل 2026).
 * Returns a Date object or null if unparseable.
 */
export function parseDate(dateStr) {
  if (!dateStr || typeof dateStr !== 'string') return null
  const trimmed = dateStr.trim()

  // ISO format: 2026-04-13 or 2026-04-13T00:00:00
  const isoMatch = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (isoMatch) {
    const d = new Date(parseInt(isoMatch[1]), parseInt(isoMatch[2]) - 1, parseInt(isoMatch[3]))
    return isNaN(d.getTime()) ? null : d
  }

  // Arabic format: "14 أبريل 2026" or "14 أبريل 2026 — مكتمل"
  const arMatch = trimmed.match(/(\d{1,2})\s+([\u0600-\u06FF]+)\s+(\d{4})/)
  if (arMatch) {
    const day = parseInt(arMatch[1])
    const monthName = arMatch[2].toLowerCase()
    const year = parseInt(arMatch[3])
    const month = ARABIC_MONTHS[monthName]
    if (month !== undefined) {
      const d = new Date(year, month, day)
      return isNaN(d.getTime()) ? null : d
    }
  }

  // Fallback to native Date parser
  const d = new Date(trimmed)
  return isNaN(d.getTime()) ? null : d
}

export function formatDate(dateStr) {
  const d = parseDate(dateStr)
  if (!d) return dateStr || '—'
  return d.toLocaleDateString('ar-SA', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

/**
 * Days remaining until dateStr. Returns:
 *  - positive number: days until due
 *  - 0: due today
 *  - negative: overdue (days past due)
 *  - null: unparseable date
 */
export function daysRemaining(dateStr) {
  const due = parseDate(dateStr)
  if (!due) return null
  const now = new Date()
  now.setHours(0, 0, 0, 0)
  due.setHours(0, 0, 0, 0)
  return Math.ceil((due - now) / (1000 * 60 * 60 * 24))
}

// ─── Alert System ───

/**
 * Scan all milestones for overdue tasks and tasks due within 24 hours.
 * Returns an array of alert objects sorted by severity (overdue first).
 */
export function getAlerts(milestoneData) {
  const alerts = []
  const now = new Date()

  for (const milestone of milestoneData) {
    for (const task of milestone.tasks) {
      // Skip completed tasks
      if (task.status === 'done') continue

      const due = parseDate(task.dueDate)
      if (!due) continue

      const diffMs = due.getTime() - now.getTime()
      const diffHours = diffMs / (1000 * 60 * 60)
      const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24))

      if (diffDays < 0) {
        // OVERDUE
        alerts.push({
          severity: 'overdue',
          taskName: task.name,
          taskId: task.id,
          milestoneName: milestone.name,
          product: milestone.product,
          dueDate: task.dueDate,
          daysOverdue: Math.abs(diffDays),
          assignee: task.assignee,
          notes: task.notes,
        })
      } else if (diffHours <= 24 && diffHours >= 0) {
        // WARNING — due within 24 hours
        alerts.push({
          severity: 'warning',
          taskName: task.name,
          taskId: task.id,
          milestoneName: milestone.name,
          product: milestone.product,
          dueDate: task.dueDate,
          hoursRemaining: Math.round(diffHours),
          assignee: task.assignee,
          notes: task.notes,
        })
      }
    }
  }

  // Sort: overdue first
  alerts.sort((a, b) => {
    if (a.severity === 'overdue' && b.severity !== 'overdue') return -1
    if (a.severity !== 'overdue' && b.severity === 'overdue') return 1
    return 0
  })

  return alerts
}

// ─── Project Status ───

/**
 * Compute a task's derived status considering dates.
 * Returns: 'done' | 'in_progress' | 'pending' | 'overdue' | 'due_soon'
 */
export function getTaskDerivedStatus(task) {
  if (task.status === 'done') return 'done'
  const days = daysRemaining(task.dueDate)
  if (days === null) return task.status
  if (days < 0) return 'overdue'
  if (days <= 1) return 'due_soon'
  return task.status
}

/**
 * Get days remaining label for display.
 */
export function getDaysRemainingLabel(dateStr) {
  const days = daysRemaining(dateStr)
  if (days === null) return ''
  if (days < 0) return `${Math.abs(days)} يوم تأخير`
  if (days === 0) return 'اليوم!'
  if (days === 1) return 'غداً'
  return `${days} يوم متبقي`
}
